/**
 * This store is used to keep track of a temporary set of flashcards to navigate through
 */

const state = () => ({
  ids: [],
});

const getters = {
  ids: state => state.ids,
};

const mutations = {
  setIds(state, ids) {
    state.ids = [...ids];
  },
};

const actions = {
  setIds({ commit }, ids) {
    commit('setIds', ids);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
